import { IKnmForm } from '../../../KnmPackage/MainModule/interfaces/IKnmForm';
import { checkQuillEditorDeltaIsEmpty } from '../../../CorePackage/MainModule/validators/isRequiredQuillEditorDelta';
import { ProfKindCodesEnum } from '../../../APIPackage/DictionariesModule/enums/ProfKindCodesEnum';
import { KnmVersionsEnum } from '../../../APIPackage/KnmModule/enums/KnmVersionsEnum';

interface IMarkedField {
  appendShowMarkCondition?: (values: IKnmForm, knmSystemType?: KnmVersionsEnum) => boolean;
}

export const isFieldsRequiredForAnnouncementOfWarningRemark = (
  fieldName: string | undefined,
  values: IKnmForm,
  version?: KnmVersionsEnum,
): boolean => {
  const idRegex = /\[\d+]/gi;
  const fieldNameTemplate = fieldName?.replaceAll(idRegex, '[{id}]');

  if (!fieldNameTemplate || !fieldsRequiredForAnnouncementOfWarningRemark[fieldNameTemplate]) {
    return false;
  }

  const markedField = fieldsRequiredForAnnouncementOfWarningRemark[fieldNameTemplate];

  return !markedField.appendShowMarkCondition || markedField.appendShowMarkCondition(values, version);
};

const fieldsRequiredForAnnouncementOfWarningRemark: Record<string, IMarkedField> = {
  noteWarningReactQuillEditor: {
    appendShowMarkCondition: values => {
      return checkQuillEditorDeltaIsEmpty(values.noteWarningReactQuillEditor);
    },
  },
  inspectorsErknm: {
    appendShowMarkCondition: values => !values.inspectorsErknm || values.inspectorsErknm.length === 0,
  },
  requirementsNpa: {
    appendShowMarkCondition: values => !values.requirementsNpa || values.requirementsNpa.length === 0,
  },
  subjectNotifications: {
    appendShowMarkCondition: (values, version) => {
      const isEmpty = !values.subjectNotifications || values.subjectNotifications.length === 0;

      return version === KnmVersionsEnum.ERP ? values.pmType?.code !== ProfKindCodesEnum.OP && isEmpty : isEmpty;
    },
  },
};
